export default __webpack_public_path__ + "static/1871-c9340eef05c56cf51b103a73654c4be5.gif";